import type { ReactNode } from 'react';
import CustomCheckBox from 'src/shared-components/CustomCheckBox';

const NotificationPreferenceItem = ({
  label,
  checked,
  onClick,
  disabled = false,
}: {
  label: string | ReactNode;
  checked: boolean;
  onClick: () => void;
  disabled?: boolean;
}) => {
  return (
    <div
      className={`text-base text-[#3C3D3E] font-medium flex flex-row gap-x-2 ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      }`}
    >
      <CustomCheckBox checked={checked} onClick={onClick} />
      <span>{label}</span>
    </div>
  );
};

export default NotificationPreferenceItem;
